// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"87ac19ff","339":"cb483dc6","529":"87eae124","540":"ecd826fa","637":"3b4db9ef","661":"a9cfb7c2","698":"e59ec5aa","736":"fd1898a0","926":"82793bbf","939":"85c08db1"}[chunkId] + ".chunk.js";
};